export default {
  selected: 'Geselecteerd',
  deselect_all_selected_options: 'Alle geselecteerde opties deselecteren',
  expanded: 'Uitgebreid',
  collect: 'Verzamelen',
  no_options_available: 'Geen opties beschikbaar',
  required: 'Vereist',
  input_clear_aria_label: 'Invoer wissen',
  input_show_hide_password_aria_label: 'Wachtwoord tonen of verbergen',
  input_increment_aria_label: 'Waarde verhogen',
  input_decrement_aria_label: 'Waarde verlagen',
  english: 'Engels',
  chinese: 'Chinees',
  portuguese: 'Portugees',
  spanish: 'Spaans',
  dutch: 'Nederlands',
  french: 'Frans',
  german: 'Duits',
  russian: 'Russisch',
  ukrainian: 'Oekraïens',
  korean: 'Koreaans',
  italian: 'Italiaans',
  czech: 'Tsjechisch',
  access_your_account: 'Toegang tot uw account',
  use_your_company_credentials_to_get_started:
    'Gebruik uw bedrijfsreferenties om te beginnen',
  internal_user_login: 'Interne Gebruiker (SSO)',
  external_user_login: 'Externe Gebruiker',
  or: 'of',
  keycloak_init_error:
    'Kan geen verbinding maken met de authenticatieserver. Controleer uw netwerkverbinding en probeer het opnieuw.',
  this_link_has_expired: 'Deze link is verlopen',
  login: 'Aanmelden',
  sample_no_production_date_message: 'Productiedatum moet worden geselecteerd',
  free_comment: 'Vrije opmerking',
  save_comments: 'Opslaan & Sluiten',
  round_list_rounds: 'Rondes',
  round_edit_round: 'Bewerk Ronde',
  round_new_round: 'Nieuwe Ronde',
  round_remove_round: 'Weet u zeker dat u de Ronde wilt verwijderen?',
  round_schedule: 'Planning',
  round_tasters_unselect_all: 'Deselecteer alle proevers',
  round_tasters_select_all: 'Selecteer alle proevers',
  round_close: 'Sluit Ronde',
  round_close_message: 'Weet u zeker dat u de Ronde wilt beëindigen?',
  round_create_site_message: 'U maakt een Ronde die niet voor uw locatie is!',
  round_closed_message: 'Gesloten rondes kunnen niet worden bewerkt',
  round_status_created: 'Aangemaakt',
  round_status_samples: 'Monsters',
  round_status_scheduled: 'Gepland',
  round_status_tasters: 'Proevers',
  round_status_in_progress: 'In uitvoering',
  round_status_finished: 'Beëindigd',
  round_status_closed: 'Gesloten',
  round_schedule_start_finish_date:
    'De startdatum kan niet later zijn dan de einddatum',
  round_schedule_finish_date_no_start_date:
    'U moet eerst een startdatum selecteren',
  round_disabled_discussion_tooltip:
    'U kunt geen toegang krijgen tot een Discussie van een onvoltooide Ronde.',
  round_up_down_maintenance_tooltip:
    'Deze functie is onderhoud en tijdelijk niet beschikbaar',
  round_delete_other_users_rounds:
    'U bent niet geautoriseerd om een Ronde te verwijderen die u niet heeft gemaakt',
  round_randomize_samples_order_button: 'Schudden',
  round_block_results_tooltip:
    'Blokkeer de resultaten van deze Ronde zodat ze niet kunnen worden gedownload in het rapportenscherm. Als de knop is uitgeschakeld, heeft u niet het recht om de resultaten van Rondes vanaf deze locatie te blokkeren',
  round_block_results_confirm:
    'Weet u zeker dat u de resultaten van de Ronde wilt blokkeren/deblokkeren?',
  round_block_results_no_privilege:
    'U heeft niet het recht om de resultaten van Rondes vanaf deze locatie te blokkeren/deblokkeren.',
  sample_list_samples: 'Monsters',
  sample_edit_sample: 'Bewerk Monster',
  sample_new_sample: 'Nieuw Monster',
  sample_remove_sample: 'Verwijder Monster',
  sample_upload_document: 'Documenten uploaden',
  sample_download_documents: 'Monsterdocumenten',
  sample_tasted_dates: 'Degustatiedatum',
  sample_upload_message:
    'Om meerdere documenten te uploaden, voegt u ze toe aan een .zip-bestand',
  sample_not_for_kpi: 'Niet voor KPI',
  sample_package: 'Verpakking',
  sample_volume: 'Volume',
  sample_production_date: 'Productiedatum',
  sample_expire_date: 'Vervaldatum',
  sample_trial_identifier: 'Testidentificatiecode',
  sample_project_name: 'Projectnaam',
  sample_linked: 'Gekoppeld aan een Ronde',
  sample_expire_bigger_than_production:
    'De productiedatum kan niet later zijn dan de vervaldatum!',
  sample_no_site_message:
    'Het is verplicht om een Zone, Land en een Locatie te selecteren om een monster aan te maken.',
  sample_no_brand_message: 'Het is verplicht om een Merk te selecteren.',
  sample_duplicated_kpi_message:
    'Er bestaat al een KPI voor de maand, het merk en de locatie die u heeft geselecteerd en u kunt niet opslaan.',
  sample_duplicated_kpi_message_quarter:
    'Er bestaat al een KPI voor het kwartaal, het merk en de locatie die u heeft geselecteerd en u kunt niet opslaan.',
  sample_duplicated_project_message:
    'Er bestaat al een monster met deze projectnaam en test-ID voor deze locatie en dit merk en u kunt niet opslaan.',
  sample_project_no_name_or_trial:
    'Projectnaam en testidentificatie zijn verplicht bij het aanmaken van een monstertype Project.',
  sample_production_to_project_confirm_message:
    'U wijzigt het type van dit monster van PRODUCTIE naar PROJECT. Wilt u doorgaan?',
  sample_project_to_production_confirm_message:
    'U wijzigt het type van dit monster van PROJECT naar PRODUCTIE. Wilt u doorgaan?',
  sample_no_volume_message:
    'Verpakking en Volume zijn verplicht bij het aanmaken/bewerken van een monster.',
  sample_id_code_message: 'Voer het volledige batchnummer in.',
  sample_show_all_samples_hint:
    'Toon monsters die tot een jaar geleden zijn aangemaakt. Vink dit vakje aan als u ook oudere monsters wilt zien.',
  sample_show_all_samples_label: 'Toon alle Monsters',
  package_duplicate: 'Er bestaat al een verpakking met deze naam',
  common_production: 'Productie',
  day: 'dag',
  common_project: 'Project',
  group_list_groups: 'Groepen',
  group_edit_group: 'Bewerk Groep',
  group_new_group: 'Nieuwe Groep',
  group_remove_group: 'Verwijder Groep',
  group_close_modal: 'Sluiten',
  group_duplicated_user: 'Deze gebruiker is al toegevoegd aan deze groep!',
  group_no_name_message: 'Het is nodig om een groepsnaam in te voeren.',
  group_no_zone_message: 'Het is noodzakelijk om een Zone te selecteren.',
  group_no_users_message:
    'Het is noodzakelijk om ten minste één proever te selecteren.',
  family_list_families: 'Stijlen',
  family_edit_family: 'Bewerk Stijl',
  family_new_family: 'Nieuwe Stijl',
  family_remove_family: 'Verwijder Stijl',
  families_page_description:
    'Beheer alle stijlen en hun configuraties op één plek',
  family_new_page_description:
    'Vul de stijlinformatie in en voltooi de aanmaak.',
  family_edit_page_description: 'Bewerk stijlinformatie.',
  family_save_success: 'Stijl succesvol aangemaakt!',
  family_update_success: 'Stijl succesvol bijgewerkt!',
  family_save_failed: 'Stijl opslaan mislukt.',
  family_save_success_desc: 'Bekijk het in de stijlen hieronder.',
  family_update_success_desc: 'Bekijk het in de stijlen hieronder.',
  family_save_failed_desc: 'Probeer het over een moment opnieuw.',
  the_name_is_duplicated: 'Deze naam bestaat al.',
  common_style_name: 'Stijlnaam',
  common_warning: 'Waarschuwing',
  cancel_new_family_title: 'Nieuwe stijl annuleren?',
  cancel_edit_family_title: 'Stijlbewerking annuleren?',
  cancel_new_family_confirm: 'Nieuwe stijl annuleren',
  cancel_edit_family_confirm: 'Stijlbewerking annuleren',
  family_remove_success: 'Stijl succesvol verwijderd',
  family_remove_failed: 'Stijl verwijderen mislukt',
  family_delete_title: 'Stijl verwijderen?',
  family_delete_description:
    'De stijl {{name}} wordt permanent verwijderd. Weet u zeker dat u wilt doorgaan?',
  family_delete_success: 'Stijl succesvol verwijderd!',
  family_delete_success_desc: 'De stijl is verwijderd.',
  family_delete_failed: 'Stijl verwijderen mislukt.',
  family_delete_failed_desc: 'Probeer het over een moment opnieuw.',
  family_has_no_english_name:
    'Het is verplicht om de stijlnaam in het Engels te hebben.',
  brand_list_brands: 'Merken',
  brand_edit_brand: 'Bewerk Merk',
  brand_new_brand: 'Nieuw Merk',
  brand_remove_brand: 'Verwijder Merk',
  brand_profile_picture: 'Upload Bierprofielfoto',
  brand_upload_brand_logo: 'Upload Merklogo',
  brand_duplicate: 'Let op: er bestaat al een bier met deze naam',
  brand_has_no_english_name:
    'U moet een merknaam en een bijbehorend bierprofiel invoeren.',
  brand_upload_help_message: 'Alleen PNG- en JPG-bestanden',
  brand_has_no_product_type: 'U moet een producttype selecteren.',
  package_list_packages: 'Verpakkingen',
  package_edit_package: 'Bewerk Verpakking',
  package_new_package: 'Nieuwe Verpakking',
  package_remove_package: 'Verwijder Verpakking',
  packages_page_description:
    'Beheer alle verpakkingstypen en hun configuraties op één plek.',
  comments_page_description:
    'Beheer alle attributen en hun configuraties op één plek.',
  comments_new_page_description:
    'Vul de attribuutinformatie in en voltooi de aanmaak.',
  comments_edit_page_description:
    'Bewerk de attribuutinformatie en voltooi de update.',
  comment_attribute_name: 'Naam van het smaakattribuut',
  comment_select_category: 'Selecteer de smaakcategorie',
  packages_edit_page_description:
    'Bewerk de verpakkingsinformatie en voltooi de update.',
  package_successfully_created: 'Verpakking succesvol aangemaakt!',
  package_successfully_created_desc:
    'Bekijk het in de onderstaande verpakkingen.',
  package_successfully_updated: 'Verpakking succesvol bijgewerkt!',
  package_successfully_updated_desc:
    'Bekijk het in de onderstaande verpakkingen.',
  packages_new_page_description:
    'Vul de verpakkingsinformatie in en voltooi de aanmaak.',
  package_name: 'Naam van de verpakking',
  content_already_exists: 'Inhoud bestaat al.',
  language_english: 'Engels',
  language_chinese: 'Chinees',
  language_portuguese: 'Portugees',
  language_spanish: 'Spaans',
  language_dutch: 'Nederlands',
  language_french: 'Frans',
  language_german: 'Duits',
  language_russian: 'Russisch',
  language_ukrainian: 'Oekraïens',
  language_korean: 'Koreaans',
  language_italian: 'Italiaans',
  package_has_no_english_name:
    'Het is verplicht om de naam van de Verpakking in het Engels te hebben.',
  package_volumes: 'Volumes',
  package_new_volume: 'Nieuw Volume',
  package_remove_volume: 'Verwijder Volume',
  degree_list_degrees: 'Intensiteiten',
  degree_edit_degree: 'Bewerk Intensiteit',
  degree_new_degree: 'Nieuwe Intensiteit',
  degree_remove_degree: 'Verwijder Intensiteit',
  category_list_categories: 'Categorieën',
  category_edit_category: 'Bewerk Smaakcategorie',
  category_new_category: 'Nieuwe Smaakcategorie',
  category_remove_category: 'Verwijder Smaakcategorie',
  comment_list_comments: 'Attributen',
  comment_edit_comment: 'Bewerk Smaakattribuut',
  comment_new_comment: 'Nieuw Smaakattribuut',
  comment_remove_comment: 'Verwijder Smaakattribuut',
  comment_cancel_new_title: 'Nieuw smaakattribuut annuleren?',
  comment_cancel_edit_title: 'Smaakattribuut bewerken annuleren?',
  comment_cancel_new_confirm: 'Nieuw smaakattribuut annuleren',
  comment_cancel_edit_confirm: 'Smaakattribuut bewerken annuleren',
  comment_successfully_created: 'Smaakattribuut succesvol aangemaakt!',
  comment_successfully_created_desc: 'Bekijk het in het attribuut hieronder.',
  comment_successfully_updated: 'Smaakattribuut succesvol bijgewerkt!',
  comment_successfully_updated_desc: 'Bekijk het in het attribuut hieronder.',
  comment_create_failed: 'Smaakattribuut aanmaken mislukt.',
  comment_update_failed: 'Smaakattribuut bijwerken mislukt.',
  comment_failed_desc: 'Probeer het zo meteen opnieuw.',
  comment_delete_title: 'Attribuut verwijderen?',
  comment_delete_description:
    'Attribuut {{name}} wordt permanent verwijderd. Weet je zeker dat je wilt doorgaan?',
  comment_delete_success: 'Attribuut succesvol verwijderd!',
  comment_delete_success_desc: 'Bekijk het in het attribuut hieronder.',
  comment_delete_failed: 'Attribuut verwijderen mislukt.',
  comment_delete_failed_desc: 'Probeer het zo meteen opnieuw.',
  user_list_users: 'Gebruikers',
  user_edit_user: 'Bewerk Gebruiker',
  user_new_user: 'Nieuwe ABI-contractant',
  user_export_users: 'Exporteer Gebruikers',
  user_list_profiles: 'Profielen',
  user_profile_name: 'Profielnaam',
  user_profile_select: 'Selecteer Profiel',
  user_profile_remove: 'Verwijder Profiel',
  user_profile_save: 'Bewaar Profiel',
  user_remove_user: 'Verwijder Gebruiker',
  user_use_terms: 'Geaccepteerde gebruiksvoorwaarden',
  report_list_report: 'Rapporten',
  report_start_date: 'Startdatum',
  report_end_date: 'Einddatum',
  common_privileges: 'Rechten',
  common_abi_name: 'ABI-naam',
  common_id: 'ID',
  common_ranked: 'Gerangschikt',
  common_week: 'Week',
  common_weeks: 'Weken',
  common_days: 'Dagen',
  common_category: 'Smaakcategorie',
  common_category_sample: 'Categorie',
  common_degree: 'Intensiteit',
  common_comment: 'Smaakattribuut',
  common_status: 'Status',
  common_zone: 'Zone',
  common_country: 'Land',
  common_site: 'Locatie',
  common_start_date: 'Startdatum',
  common_finish_date: 'Einddatum',
  common_round_type: 'Testtype',
  common_type: 'Type',
  common_round: 'Ronde',
  common_round_id: 'ID Ronde',
  common_tasters: 'Proevers',
  common_sample_performance: 'Monsterprestaties',
  common_taste: 'Smaak',
  common_key_taster: 'Hoofdproever',
  common_sample: 'Monster',
  common_samples: 'Monsters',
  common_sample_type: 'Type Monster',
  common_family: 'Stijl',
  common_brand: 'Merk',
  common_product_type: 'Producttype',
  common_temperature: 'Opslagvoorwaarden',
  common_storage_times: 'Opslagtijd',
  common_sku: 'SKU',
  common_batch: 'ID-code',
  common_kpi_month: 'KPI-maand',
  common_logo: 'Logo',
  common_name: 'Naam',
  common_notes: 'Notities',
  common_email: 'E-mailadres',
  common_language: 'Taal',
  common_terms_of_use: 'Gebruiksvoorwaarden',
  common_profile: 'Profiel',
  common_filter: 'Filter Gebruikers',
  common_download: 'Downloaden',
  download: 'Downloaden',
  common_save: 'Opslaan',
  common_cancel: 'Annuleren',
  cancel_add_taster_title: 'Taster toevoegen annuleren?',
  cancel_add_taster_description:
    'Je hebt al tasters geselecteerd. Als je annuleert, wordt je selectie verwijderd. Wil je doorgaan?',
  cancel_add_taster_confirm: 'Taster toevoegen annuleren',
  cancel_enter_concentration_title: 'Invoer van concentratie annuleren?',
  cancel_enter_concentration_description:
    'Je hebt een concentratiewaarde ingevoerd. Als je annuleert, wordt de niet-opgeslagen invoer verwijderd. Wil je doorgaan?',
  cancel_enter_concentration_confirm: 'Invoer van concentratie annuleren',
  cancel_new_package_title: 'Nieuwe verpakking annuleren?',
  cancel_edit_package_title: 'Verpakking bewerken annuleren?',
  cancel_new_package_confirm: 'Nieuwe verpakking annuleren',
  cancel_edit_package_confirm: 'Verpakking bewerken annuleren',
  common_search_users: 'Zoek Gebruikers',
  common_search_group: 'Zoek Groep',
  common_search_taster: 'Zoek Proever',
  common_no_data: 'Geen gegevens om weer te geven',
  common_edit: 'Bewerken',
  no_results_found_for_applied_filters:
    'Geen resultaten gevonden voor de toegepaste filters',
  common_loading: 'Laden...',
  common_search: 'Zoeken...',
  type_more_characters: 'Typ nog {{count}} teken(s)...',
  common_cannot_be_empty: '{{field}} mag niet leeg zijn',
  common_select_option: 'Selecteer optie...',
  search_placeholder: 'Zoeken...',
  no_search_results: 'Geen resultaten gevonden',
  clear_selection: 'Selectie wissen',
  common_per_page: 'Rijen per pagina',
  common_attributes: 'Attributen',
  common_not_started: 'Niet gestart',
  common_in_progress: 'In uitvoering',
  common_finished: 'Voltooid',
  common_start: 'Start',
  common_detail: 'View Details',
  common_delete: 'Verwijderen',
  common_position: 'Positie',
  common_score: 'Score',
  common_score_scale: 'Scoreschaal',
  common_intensity: 'Intensiteit',
  common_report_not_have_data: 'De geselecteerde rondes hebben geen stemmen',
  month_0: 'Januari',
  month_1: 'Februari',
  month_2: 'Maart',
  month_3: 'April',
  month_4: 'Mei',
  month_5: 'Juni',
  month_6: 'Juli',
  month_7: 'Augustus',
  month_8: 'September',
  month_9: 'Oktober',
  month_10: 'November',
  month_11: 'December',
  dropdown_change_picture: 'Wijzig Afbeelding',
  dropdown_language: 'Taal',
  dropdown_logout: 'Afmelden',
  logout_title: 'Afmelden, wacht alstublieft…',
  logout_description: 'U wordt uit uw account afgemeld.',
  round_not_started: 'Niet gestart',
  round_in_progress: 'In uitvoering',
  round_finished: 'Voltooid',
  round_filter_start: 'Start',
  tasting_list_rounds: 'Rondelijst',
  menu_tasting_session: 'Proefsessie',
  menu_panel_management: 'Paneelbeheer',
  menu_process_management: 'Procesbeheer',
  menu_product_management: 'Productbeheer',
  menu_attributes_management: 'Attributenbeheer',
  tasting_finish_sample: 'Beëindig Monster',
  tasting_comments: 'Opmerkingen',
  tasting_beer_profile: 'Bierprofiel',
  tasting_need_select_score_comments:
    'U moet een score instellen en ten minste één opmerking toevoegen om door te gaan...',
  tasting_finish_taste: 'Beëindig Degustatie',
  tasting_finish_tasting: 'Beëindig Degustatie',
  common_no_comments: 'Geen opmerkingen',
  previous_comments: 'Vorige opmerkingen',
  review_submit_title:
    'Weet u zeker dat u klaar bent om uw resultaten in te dienen?',
  review_submit_description: 'U kunt dit later niet meer bewerken',
  review_finish_taste: 'Einde Degustatie',
  review_warning_sample_title: 'U heeft ongeproefde monsters!',
  review_warning_sample_description: 'Wilt u doorgaan zonder ze te proeven?',
  review_warning_sample_review: 'Controleer',
  review_warning_sample_ok: 'Doorgaan',
  review_warning_preference_description:
    'Selecteer een voorkeur voordat u doorgaat.',
  review_warning_tie_sample_title: 'U heeft gelijke monsters!',
  review_warning_tie_sample_description:
    'U kunt niet doorgaan zonder ze te rangschikken!',
  review_warning_tie_sample_review: 'Controleer',
  common_submit: 'Indienen',
  common_discussion: 'Discussie',
  discussion_order_number: 'Sorteer op Positie',
  discussion_order_brewery: 'Sorteer op Brouwerij',
  discussion_order_ranking: 'Sorteer op Ranking',
  discussion_order_brand: 'Sorteer op Merk',
  discussion_order_score: 'Sorteer op Score',
  discussion_order_key_score: 'Sorteer op Hoofdscore',
  discussion_order_overall_rank: 'Sorteer op Algemene Ranking',
  discussion_order_key_rank: 'Sorteer op Hoofdrang',
  discussion_key_ranking: 'Hoofdrangschikking',
  discussion_export_error: 'Het bestand kon niet worden opgeslagen!',
  discussion_ranking: 'Ranking',
  discussion_overall_ranking: 'Algemene Ranking',
  common_brewery: 'Brouwerij',
  common_trial_identifier: 'Test-ID',
  common_key_score: 'Hoofdscore',
  round_report: 'Exporteer naar Excel',
  common_comments: 'Opmerkingen',
  common_message_empty_profile: 'Profielnaam mag niet leeg of blanco zijn.',
  common_message_out_score_range: 'Score buiten bereik',
  tasting_need_select_score: 'U moet eerst een score instellen!',
  common_category_name: 'Categorie',
  categories_new_category: 'Nieuwe Categorie',
  categories_remove_category: 'Wilt u de Categorie echt verwijderen?',
  categories_list_categories: 'Categorielijst',
  common_category_sample_name: 'Monsters',
  categories_new_category_sample: 'Nieuw Monster',
  categories_remove_category_sample: 'Wilt u het Monster echt verwijderen?',
  categories_list_categories_samples: 'Monsterlijst',
  common_duplicate: 'Dupliceren',
  tasting_raw_materials: 'Grondstoffen',
  tasting_example_sensory_risk:
    'Voorbeeld van belangrijk sensorisch risico: niet-overeenstemming met de verwachte smaak',
  tasting_procedure: 'Procedure',
  tasting_sample_preparation: 'Monstervoorbereiding',
  common_collection_point: 'Verzamelpunt',
  common_collection_date: 'VerzamelDatum',
  common_brew_number: 'Brouwnummer/MES-nummer',
  common_need_explain_nok: 'U kunt geen NOK-monsters hebben zonder opmerking!',
  common_show_all: 'Toon alles',
  common_import: 'Importeren',
  common_download_template: 'Download sjabloon',
  common_create_action: 'Actie aanmaken',
  common_action_list: 'Actielijst',
  common_create_action_description: 'Vul de actiedetails voor dit monster in.',
  common_optional: 'optioneel',
  action_deadline: 'Deadline',
  action_description: 'Actiebeschrijving',
  action_description_autofill_tooltip: 'Actiebeschrijving',
  action_description_autofill_tooltip_description:
    'Automatisch gegenereerd (Ronde-ID / Brouwerij / Monsternaam / Productiedatum / Aanmakende gebruiker) + aanvullende beschrijving',
  action_owner: 'Eigenaar',
  action_meeting: 'Interactielog-meeting',
  action_meeting_list: 'IAL-meeting',
  action_producing_site: 'Productielocatie',
  action_production_date: 'Productiedatum',
  action_closed_time: 'Sluitingstijd',
  action_meeting_placeholder: 'Selecteer een meeting',
  action_status: 'Status',
  action_status_draft: 'Concept',
  action_status_not_started: 'Niet gestart',
  action_status_in_progress: 'In uitvoering',
  action_status_delayed: 'Vertraagd',
  action_status_close: 'Sluiten',

  action_menu_close: 'Sluiten',
  common_view_details: 'Details bekijken',
  action_cancel: 'Annuleren',
  action_add_comment: 'Commentaar toevoegen',
  action_status_canceled: 'Geannuleerd',
  status_record: 'Statusgeschiedenis',
  no_status_record: 'Geen statusrecords',
  action_type: 'Actietype',
  action_create_user: 'Aangemaakt door',
  action_create_time: 'Aanmaaktijd',
  action_creator: 'Maker',
  action_root_cause: 'Hoofdoorzaak',
  action_description_placeholder: 'Voer de actiebeschrijving in...',
  action_root_cause_placeholder: 'Voer de hoofdoorzaak in...',
  action_comment_added: 'Opmerking succesvol toegevoegd',
  action_comment_add_failed: 'Kan geen opmerking toevoegen',
  action_comment_placeholder: 'Voer uw opmerking in...',
  action_status_changed_with_comment: 'Status gewijzigd met opmerking',
  required_comment_banner:
    'Aangezien u niet de eigenaar bent van deze actie, moet u namens de eigenaar een opmerking maken.',
  cancel_and_comment: 'Annuleren en reageren',
  close_and_comment: 'Sluiten en reageren',
  action_edit_action: 'Actie bewerken',
  action_owner_placeholder: 'Selecteer een actie-eigenaar',
  action_created_successfully: 'Actie is succesvol aangemaakt!',
  action_created_successfully_desc:
    'Bekijk de aangemaakte actie in de actielijst.',
  action_updated_successfully: 'Actie is succesvol bijgewerkt!',
  action_updated_successfully_desc:
    'Bekijk de bijgewerkte actie in de actielijst.',
  action_create_failed:
    'Er is een probleem opgetreden bij het aanmaken van de actie',
  action_update_failed:
    'Er is een probleem opgetreden bij het bijwerken van de actie',
  action_save_failed_desc: 'Probeer het zo opnieuw.',
  action_deleted_successfully: 'Actie is succesvol verwijderd!',
  action_deleted_successfully_desc: 'Bekijk het in de actielijst.',
  action_delete_failed:
    'Er is een probleem opgetreden bij het verwijderen van de actie',
  delete_action_confirm_title: 'Actie verwijderen?',
  delete_action_confirm_description:
    'Deze actie wordt permanent verwijderd. Weet u zeker dat u wilt doorgaan?',
  action_added_notification: '[{{userName}}] heeft een nieuwe actie toegevoegd',
  action_updated_notification: '[{{userName}}] heeft zijn actie bijgewerkt',
  action_deleted_notification:
    '[{{userName}}] heeft zijn eigen actie verwijderd',
  view_action_list: 'Actielijst bekijken',
  common_need_volte_first:
    'U kunt geen opmeringen plaatsen bij monsters zonder eerst te stemmen!',
  common_yes: 'Ja',
  common_no: 'Nee',
  common_only_kpi_sample: 'Alleen KPI-Monster',
  common_name_template: 'Sjabloonnaam',
  common_all: 'Alles',
  common_continue: 'Doorgaan',
  common_minimum_score: 'Minimumscore',
  common_maximum_score: 'Maximumscore',
  common_average_score: 'Gemiddelde score',
  file_upload_fail:
    'Het uploaden van het bestand is mislukt. De volgende fouten zijn opgetreden:',
  file_upload_success_with_error:
    'Upload succesvol, met uitzondering van het volgende:',
  missing_fields: 'ontbrekende velden',
  column_error: 'kolomfout',
  common_line: 'Regel',
  file_no_messages: 'Geen monsters gevonden in het bestand!',
  file_success_upload: 'Bestand succesvol geüpload!',
  file_duplicated_kpi_project: 'Dubbele KPI of Project',
  round_schedule_maximum_length:
    'De maximale lengte van de rondenaam is 40 tekens.',
  sample_malt_varieties: 'Moutvariëteiten',
  malt_varieties_has_no_english_name:
    'U moet ten minste één moutvariëteitnaam hebben.',
  malt_varieties_duplicate:
    'Let op: er bestaat al een moutvariëteit met deze naam',
  malt_varieties_remove: 'Moutvariëteit verwijderen',
  common_back: 'Terug',
  common_next: 'Volgende',
  malt_varieties_new: 'Nieuwe Variëteit',
  malt_varieties_edit: 'Variëteit bewerken',
  malt_varieties_enter_name: 'Voer naam in',
  malt_varieties_page_description:
    'Beheer alle moutvariëteiten en hun configuraties op één plek.',
  malt_varieties_save_success: 'Moutvariëteit succesvol aangemaakt!',
  malt_varieties_save_success_desc:
    'Bekijk het in de moutvariëteiten hieronder.',
  malt_varieties_update_success: 'Moutvariëteit succesvol bijgewerkt!',
  malt_varieties_update_success_desc:
    'Bekijk het in de moutvariëteiten hieronder.',
  malt_varieties_delete_title: 'Moutvariëteit verwijderen?',
  malt_varieties_delete_description:
    'Moutvariëteit {{name}} wordt permanent verwijderd. Weet u zeker dat u wilt doorgaan?',
  malt_varieties_delete_success: 'Moutvariëteit succesvol verwijderd!',
  malt_varieties_delete_success_desc:
    'Bekijk het in de moutvariëteiten hieronder.',
  malt_varieties_delete_failed: 'Moutvariëteit verwijderen mislukt.',
  malt_varieties_delete_failed_desc: 'Probeer het later opnieuw.',
  cancel_new_malt_variety_title: 'Nieuwe moutvariëteit annuleren?',
  cancel_edit_malt_variety_title: 'Moutvariëteitbewerking annuleren?',
  cancel_new_malt_variety_confirm: 'Nieuwe moutvariëteit annuleren',
  cancel_edit_malt_variety_confirm: 'Moutvariëteitbewerking annuleren',
  reports_no_dates: 'Startdatum en Einddatum zijn verplicht!',
  reports_date_range_message: 'Datumbereik mag niet groter zijn dan 1 jaar',
  round_save_select_site:
    'Om een Ronde op te slaan moet u een locatie selecteren',
  common_horizontal: 'Horizontaal',
  common_unit: 'Eenheid',
  common_supplier: 'Leverancier',
  common_flavor: 'Smaak',
  concentration_of_the_base_beer: 'Concentratie van het basisbier',
  threshold_aml_method: 'AML-methode (oplopende limietenmethode)',
  threshold_component_concentration: 'Componentconcentratie',
  threshold_sample_different_help: 'Welk monster is anders?',
  threshold_each_set_random_order: 'In elke set willekeurige volgorde.',
  threshold_select_base_beer: 'Selecteer Basisbier',
  common_unity: 'Eenheid',
  common_finish_session: 'Sessie Beëindigen',
  common_filters: 'Filters',
  review_submit_threshold: 'Weet u zeker dat u wilt opslaan?',
  threshold_coder_wrong: 'Uw code is onjuist. Voer de juiste code in!',
  threshold_didnt_enter_the_code: 'Voer uw stoelnummer in',
  code: 'Code',
  threshold_samples_required: 'Basisbier en smaak zijn vereist',
  threshold_information_helper_sample:
    'Om drempelwaarde-informatie op te slaan, klikt u op de knop Opslaan om uw wijzigingen te bewaren',
  code_digits: 'Voer de 3-cijferige code in die aan u is toegewezen',
  common_batch_code: 'Batchcode',
  threshold_sample_spiked_with:
    'Kies in elke set het monster dat is verrijkt met ',
  threshold_code_already_tasted:
    'Deze code is al geproefd door een andere gebruiker. Voer een andere code in.',
  common_kpi_brands: 'KPI-Merken',
  common_year: 'Jaar',
  common_action: 'Actie',
  kpi_brand_details_title: 'KPI-Merk Details',
  kpi_brand_details_description:
    'Bekijk volledige informatie en de status van het goedkeuringsproces.',
  approval_action: 'Goedkeuringsactie',
  select_approval_action: 'Selecteer een goedkeuringsactie',
  reject_reason_title: 'Afwijzingsreden',
  reject_reason_description: 'Geef een reden voor de afwijzing.',
  reject_reason_label: 'Afwijzingsreden',
  reject_reason_placeholder: 'Voer afwijzingsreden in...',
  reject_reason_placeholder_site:
    "Voer de reden in voor het afwijzen van deze site '{{site}}'...",
  common_confirm: 'Bevestigen',
  common_success: 'Succes',
  common_save_failed: 'Opslaan mislukt. Probeer het opnieuw.',
  approval_status_saved_success: 'Goedkeuringsstatus succesvol opgeslagen!',
  common_comment_by_category: 'Opmerkingen per Categorie',
  common_alphabetic_comment: 'Alfabetische Opmerkingen',
  common_name_pts_code: 'PTS-code',
  common_name_pts_code_placeholder: 'Code',
  common_name_process_item: 'Procesitem',
  common_name_process_item_placeholder: 'Item',
  kpi_only_numbers_warning: 'Accepteer alleen getallen voor Doelwaarden',
  kpi_max_number_range_warning: 'Uw doelwaarde moet tussen 1 en 9 liggen.',
  kpi_already_selected_brand_warning:
    'U heeft dit merk al geselecteerd, kies een ander merk.',
  kpi_no_kpi_informed_warning: 'U heeft geen waarde toegevoegd.',
  kpi_select_year_warning: 'Selecteer een Jaar',
  kpi_select_site_warning: 'Selecteer een Locatie',
  kpi_existing_configuration_warning:
    'U heeft KPI-waarden van dezelfde locatie en hetzelfde jaar',
  kpi_target_empty_warning: 'Een doel van een van uw merken is leeg',
  kpi_saved_successfully: 'Uw waarden zijn succesvol opgeslagen!',
  kpi_submitted_successfully: 'Uw waarden zijn succesvol ingediend!',
  kpi_max_decimals_warning: 'Uw doelwaarde mag maximaal 3 decimalen hebben',
  kpi_count_as_kpi_sample: 'Tellen als KPI',
  report_list_report_kpi: 'KPI-Rapporten',
  report_list_report_taste: 'Smaakrapporten',
  select_brand_to_filter: 'Selecteer een Wereldwijd Merk!',
  select_year_to_filter: 'Kies een Jaar!',
  samples_uncheck_kpi_sample_tooltip:
    'Schakel dit selectievakje uit als u niet wilt dat dit monster telt in de KPI',
  reports_mandatory_zone_filter: 'Selecteer ten minste één Zone',
  submission_type: 'Bevestigingstype',
  custom_scale_title: 'Aangepaste Schaal',
  custom_scale_grid_header_score: 'Scores',
  custom_scale_grid_header_ageind_scale: 'Gedwongen verouderingsschaal',
  the_value_cannot_be_null: 'De waarde mag niet leeg zijn!',
  unique_id: 'Unieke identificatie',
  report_filter_rounds_description:
    'U moet de verplichte velden selecteren om ronde-opties te laden.',
  reports_mandatory_test_type: 'Selecteer het testtype.',
  round_reports_month_warning:
    'De periode tussen de startdatum en de einddatum mag maximaal 6 maanden bedragen.',
  zone_can_not_empty: 'Regio mag niet leeg zijn',
  error_loading_data:
    'Fout bij het laden van gegevens. Controleer uw verbinding en laad opnieuw.',
  beer_batch: 'Bierbatch',
  list_of_beers: 'Bierlijst',
  random: 'Willekeurig',
  preview: 'Voorbeeld',
  select_the_flavor: 'Selecteer de smaak',
  flavor_threshold: 'Smaakdrempel',
  input_digital_number: 'Digitaal nummer invoeren',
  concentration: 'Concentratie',
  flavor_order: 'Smaakvolgorde',
  last: 'Laatste',
  tasting: 'Degustatie',
  tasting_page_description:
    'Voer een monstersmaakevaluatie uit en bespreek het resultaat.',
  confirmation: 'Bevestiging',
  do_you_confirm_the_evaluation_of_this_sample:
    'Bevestigt u de evaluatie van dit monster?',
  confirm: 'Bevestigen',
  evaluate: 'Evalueer',
  correct_answer: 'Juist antwoord',
  threshold: 'Drempel',
  let_a_comment_about_the_tasting: 'Geef een opmerking over de degustatie',
  send: 'Verzenden',
  right_now: 'Onmiddellijk',
  minute_ago: 'Minuut geleden',
  hour_ago: 'Uur geleden',
  day_before: 'Dag voordien',
  year_ago: 'Jaar geleden',
  add_a_flavor: 'Voeg een smaak toe',
  soft_drinks: 'Frisdrank',
  soft_drinks_brand: 'Frisdrank merk',
  soft_drinks_brand_target: 'Merkdoel frisdrank',
  column_options: 'Kolomopties',
  configure_table_title: 'Kolommen aanpassen',
  configure_table: 'Tabel configureren',
  configure_table_description:
    'Kies de zichtbare kolommen en pas de volgorde aan.',
  configure_table_helper:
    'Er moeten minimaal 2 kolommen zichtbaar zijn en maximaal 4 kolommen kunnen worden vastgezet.',
  configure_table_fixed_left: 'Links vastgezet',
  configure_table_scroll_area: 'Scrollgebied',
  configure_table_fixed_right: 'Rechts vastgezet',
  configure_table_empty_left:
    'Sleep hier een kolom naartoe om deze links vast te zetten',
  configure_table_empty_right:
    'Sleep hier een kolom naartoe om deze rechts vast te zetten',
  configure_table_save: 'Wijzigingen opslaan',
  configure_table_reset: 'Standaard herstellen',
  configure_table_discard: 'Wijzigingen negeren',
  configure_table_show: 'Tonen',
  configure_table_hide: 'Verbergen',
  configure_table_min_visible:
    'Er moeten minimaal 2 kolommen zichtbaar blijven',
  configure_table_max_fixed: 'U kunt maximaal 4 kolommen vastzetten',
  configure_table_drag: 'Slepen om te herschikken',
  configure_table_dragging: 'Bezig met slepen',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Selecteer welke kolommen u wilt weergeven.',
  countdown: 'aftellen',
  less_than_five_minutes:
    'Deze proeverij eindigt over 5 minuten, als u verder moet gaan, neem dan contact op met de beheerder om de einddatum uit te stellen.',
  the_countdown_to_the_evaluation_has_ended:
    'Het aftellen voor de beoordeling van het artikel is voorbij en er is geen toegang tot de beoordeling van het artikel.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Bereken hoeveel tijd je nodig hebt om deze monsters te proeven',
  only_six_flavors_can_be_added_at_most:
    'Er kunnen maximaal zes smaken worden toegevoegd!',
  concentration_of_the_flavor: 'Concentratie van de smaak',
  input_value: 'Invoerwaarde',
  Concentration_of_the_flavor_is_required:
    'Concentratie van de smaak is vereist',
  previous_round: 'Vorige ronde',
  next_round: 'Volgende ronde',
  the_end_time_is_greater_than_the_current_time:
    'De eindtijd moet groter zijn dan de huidige tijd, als u dezelfde dag als de huidige dag selecteert, selecteert u eerst het uur en de minuut!',
  check_the_answer_at_the_end_of_the_countdown:
    'Het aftellen is nog niet voorbij, u kunt de antwoorden na het aftellen bekijken',
  incremental_step: 'Incrementele stap',
  set3_concentration: 'Set3 Concentratie',
  concentration_increments_between_levels:
    'Concentratieverhogingen tussen niveaus',
  incremental_set3_concentration_required:
    'Incrementele stap en Set3 concentratie zijn vereist',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'Sprintnummer moet groter zijn dan 0',
  sprint_notes_at_least_one_note:
    'Sprintnotities moeten ten minste één notitie hebben',
  sprint_patch_notes_success_update:
    'Sprint patch-notities bijgewerkt met succes.',
  sprint_patch_notes_error_update:
    'Het was niet mogelijk om de notities op te slaan.',
  sprint_number: 'Sprintnummer',
  sprint_patch_notes: 'Sprint patch-opmerkingen',
  note: 'Opmerking',
  select_all: 'Alles selecteren',
  please_add_samples_first: 'Voeg eerst monster toe',
  reverse: 'Terugdraaien',
  new_test: 'Toegevoegde tests',
  triangle_test_name: 'Naam triangulatietest',
  triangle_test: 'Triangulatietest',
  you_can_not_set_three_identical_samples:
    'U kunt niet dezelfde drie opties instellen',
  its_mandatory_to_input_test_name: 'Gelieve de naam van de test in te vullen',
  its_mandatory_to_input_sample_information:
    'Gelieve de voorbeeldinformatie in te vullen',
  attention: 'Attentie',
  test_number: 'Serienummer van de triangulatietest',
  you_selected_the: 'U heeft gekozen',
  next_sample: 'Volgend Monster',
  remove_triangle_test: 'Triangulatietest verwijderen',
  you_can_only_select_up_to_five: 'Maximaal vijf selecties zijn toegestaan',
  test: 'Test',
  confirm_remove: 'Bevestigt u de verwijdering van de test?',
  reports_mandatory_zone_country_site_filter:
    "Regio's, landen, fabrieken zijn vereist!",
  reports_mandatory_brand_filter: 'Selecteer ten minste één merk',
  reports_by_producing_site: 'Volledig analyserapport',
  download_label: 'Knop Downloaden',
  standard: 'Standaardwaarde',
  input_test: 'Invoer van resultaten',
  detecting: 'Opsporen...',
  connected: 'Verbonden',
  current_taster: 'Huidige reviewers',
  alcohol_concentration: 'Alcohol concentratie',
  alcohol_result_submit_failed_title:
    'Er is een probleem opgetreden bij het indienen van het resultaat',
  alcohol_result_submit_failed_desc: 'Probeer het over een moment opnieuw.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    'Uw alcoholconcentratie in het bloed is te hoog. Gelieve later opnieuw te testen!',
  alcohol_test_qualified: 'Slaag voor de alcoholtest',
  alcohol_concentration_configuration: 'Configuratie alcoholconcentratie',
  breathalyzer_configuration_description:
    'Configureer de alcoholconcentratie voor elke locatie en de rijstatus van gebruikers.',
  breathalyzer_configuration_save_success_title: 'Breathalyzer-configuratie succesvol bijgewerkt!',
  breathalyzer_configuration_save_success_description: 'Bekijk de bijgewerkte configuraties in de onderstaande instellingen.',
  breathalyzer_configuration_save_failed_title: 'Er is een probleem opgetreden bij het bijwerken van de Breathalyzer-configuratie',
  breathalyzer_configuration_save_failed_description: 'Probeer het zo meteen opnieuw.',
  cancel_configuration_title: 'Configuratie annuleren?',
  cancel_configuration_description: 'U hebt wijzigingen in de configuratie aangebracht. Bij annuleren gaan uw niet-opgeslagen wijzigingen verloren. Wilt u doorgaan?',
  cancel_configuration_confirm: 'Configuratie annuleren',
  driving_configuration: 'Rijconfiguratie',
  configuration: 'Aanleg',
  input_result: 'Invoer van resultaten',
  maximum_alcohol_concentration: 'Overmatige alcoholconcentratie',
  breathalyzer: 'Alcohol detector',
  breathalyzer_page_description:
    'Beheer alle blaastestresultaten en configuratiestandaarden op één plek.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Voer een positief getal in tot {{field}} decimalen',
  you_must_input: 'U moet invoeren',
  driving: 'Rijden',
  test_time: 'Testtijd',
  input_type: 'Soort invoer',
  list_breathalyzer: 'Ademhalingsalyser',
  Manual: 'Handmatig',
  auto: 'Automatisch',
  Breathalyzer: 'Ademhalingsalyser',
  you_do_not_have_privilege_to_export_this_report:
    'U hebt geen bevoegdheid om dit rapport te exporteren',
  competitor_beer: 'Bier van de concurrent',
  split_round: 'Ronde splitsen',
  reset: 'Reset',
  how_many_rounds_splitting_do_you_want_to_make:
    'Hoeveel rondes splitsen wil je maken',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'U kunt een ronde die al is gesplitst of in uitvoering is niet splitsen',
  hide_sample_details: 'Voorbeeldgegevens verbergen',
  hide_sample_details_auto_hide:
    'YES - je kunt de monsters splitsen en alle verborgen informatie automatisch weergeven nadat alle gesplitste rondes zijn geproefd.',
  hide_sample_details_manual_hide:
    'Manual - u kunt de voorbeelden niet opsplitsen en moet een tijdelijke beheerder toewijzen om handmatig te wisselen tussen afdekken of verbergen op de discussiepagina.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Gegevens worden verborgen voor de proever: Brouwerij, productiedatum, merk, moutsoort en monster ID',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    'Als deze ronde op Manual staat, is de splitsfunctie niet beschikbaar. Je kunt kiezen voor Automatisch verbergen of Niet verbergen om te splitsen.',
  data_will_be_hidden_for_ok_nok:
    'Alle relevante gegevens worden voor de proevers verborgen.',
  you_can_not_add_duplicate_attributes:
    'U kunt geen dubbele attributen toevoegen.',
  menu: 'MENU',
  link_breathalyzer: 'Verbonden',
  not_link_breathalyzer: 'Onverbonden',
  breathalyzer_to_link: 'Breathalyzer verbinden',
  breathalyzer_connection_failed_title:
    'Verbinding met de blaastest is mislukt',
  breathalyzer_connection_failed_desc:
    'Vernieuw de pagina en probeer het opnieuw.',
  breathalyzer_can_not_to_link_for_this_browser:
    'De ademanalysefunctie is ontwikkeld om te werken op Google Chrome, met behulp van pc-apparaten.',
  reopen: 'Opnieuw openen',
  round_reopen_message: 'Weet je zeker dat je de ronde wilt heropenen',
  common_production_line: 'Productielijn',
  common_packaged_beer_data_code: 'Code voor verpakte biergegevens',
  common_masking_process_for_bottles: 'Maskerproces voor flessen',
  common_str_number_days_over_aged: 'Aantal dagen bij overmatige leeftijd',
  common_over_aged_beer: 'Oververouderd bier',
  sample_successfully_swapped: 'De uitwisseling van monsters was succesvol.',
  scoring: 'Scoring',
  configure_available_flavors: 'Beschikbare smaken instellen',
  process_check: 'Procescontrole',
  new_process_check: 'Nieuwe procescontrole',
  edit_process_check: 'Procescontrole bewerken',
  remove_process_check: 'Procescontrole verwijdere',
  common_package: 'Pakket',
  common_department: 'Afdeling',
  common_shift: 'Shift',
  common_tank: 'Tank',
  common_oknok: 'OKNOK',
  common_remark: 'Opmerkingen',
  show_all_process_check: 'Alle procescontrole tonen',
  show_all_process_check_help_circle:
    'Toon de gegevens die binnen een half jaar na vandaag zijn gemaakt. Vink dit vakje aan als u nog gegevens wilt zien die binnen een jaar na vandaag zijn gemaakt',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'De steekproefdatum kan niet eerder zijn dan de huidige tijd!',
  common_job_position: 'werkpositie',
  decimal_sep: 'Decimaal scheidingsteken',
  is_swapped_to: 'Worden verwisseld voor',
  review_warning_comment_title: 'Je hebt voorbeelden zonder commentaar!',
  continuous_typing: 'Continue invoer',
  continuous_typing_tips:
    "Begin met typen van 'Attribute' na het selecteren/typen van 'Intensiteit'.",
  BSSI_Reports: 'BSSI verslag',
  data_analysis_sip: 'Gegevensanalyse - SIP',
  select_the_color: 'Selecteer de kleur',
  color: 'kleur',
  download_document: 'Bestanden downloaden',
  Month_of_Discontinued_Production: 'Aantal maanden',
  Suspension_List: 'Lijst van uit produktie genomen produkten',
  New_Suspension: 'Nieuwe aanvraag voor stopzetting van de productie',
  new_suspension_page: 'Nieuwe informatie uit productie',
  edit_suspension_page: 'Bewerken van de beeindigde informatie',
  Brand_name: 'Naam van het merk',
  List_Brewery_Production_Suspension: 'Lijst van stilgelegde fabrieken',
  Upload_successfully: 'Succesvolle upload van bestanden',
  training_materials: 'Trainingsmateriaal',
  Remove_Suspension: 'Verwijderen van de schorsing: ',
  Add_Absence_Reason: 'Redenen voor verzuim toevoegen',
  Reason: 'oorzaken',
  Select_reason: 'Selecteer reden',
  You_have_duplicate_absence_dates:
    'U heeft een aantal dagen van herhaalde afwezigheid',
  Remove_Absence: 'Geschrapt zonder: ',
  Absence_Title:
    'Selecteer het tijdstip en de reden van uw afwezigheid bij de proeverij. Bekijk of verwijder vermeldingen bij Ingediende reden.',
  Shipping_Site: 'Website voor verzending',
  shipping_received: 'verzending',
  receive_sample_alert: 'Weet u zeker dat u de monsters hebt ontvangen?',
  receive_uncheck_alert: 'Weet u zeker dat u het vinkje wilt verwijderen?',
  all_received: 'totaal',
  not_all_received: 'Niet volledig ontvangen',
  not_for_shipping: 'Niet bestemd voor vervoer',
  receive_hint: 'Selecteer alle sites die dit voorbeeld ontvangen',
  absence_reason: 'Redenen voor afwezigheid',
  Page1: 'BLZ. {{field}}',
  Search: 'zoeken',
  page_total: 'Totaal aantal',
  start_date: 'Begin datum',
  end_date: 'Eind datum',
  ok_for_all: 'Goed voor iedereen',
  its_mandatory_to_select_sample_A_and_sample_B:
    'Monsters A en B moeten worden genomen.',
  its_mandatory_to_select_sample_A: 'Monster A moet worden gekozen.',
  its_mandatory_to_select_sample_B: 'Monster B moet worden gekozen.',
  triangle_comment: 'Commentaar',
  select_sample: 'Selectie van de monsters',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Voorbeelddatumfilter, standaard laatste zeven dagen, exporteer naar Excel op basis van deze gefilterde duur.',
  select_all_flavor: 'Selecteer alles',
  deselect_all: 'Alles annuleren',
  email_distribution: 'Maandelijks verslag ontvangers',
  new_email_distribution: 'Nieuwe maandelijks verslag ontvangers',
  edit_email_distribution: 'Maandelijks verslag ontvangers bewerken',
  distribution_type: 'Distributietype',
  the_score_entered_is_invalid:
    'De ingevoerde score is ongeldig. Raadpleeg de scoreschaal en voer uw score opnieuw in.',
  service_now:
    'Klik om een evenementticket aan te maken om een probleem te melden en hulp te krijgen.',
  service_now_tips:
    'Hey, als je een probleem ziet of om ondersteuning wilt vragen, klik dan hier en meld het direct in serviceNow, ons supportteam neemt zo snel mogelijk contact met je op.',
  done: 'Gereed',
  changes_you_made_may_not_be_saved:
    'Wijzigingen die u hebt aangebracht, worden mogelijk niet opgeslagen. Wilt u doorgaan en wijzigingen verliezen?',
  cannel_auto_save_tips:
    'Nu de prestaties van de proeveringspagina is verbeterd, vergeet niet om op Voorbeeld voltooien te klikken om uw proeveringsresultaat op te slaan en in te dienen.',
  list_email_page_tips:
    'Hoe zet je de juiste KPI samples in om ervoor te zorgen dat de regionale maandelijkse rapportages een accuraat beeld geven van de analyse van MCS tasting in jouw regio',
  list_email_page_helps:
    'De instructie voor het instellen van KPI-voorbeelden om exacte gegevens in uw zone maandelijks rapport weer te geven.',
  kpi_instruction: 'KPI-instructie',
  group_no_recipients_message: 'Er is ten minste één ontvanger nodig.',
  the_current_distribution_type_already_exists:
    'Het huidige distributietype bestaat al, selecteer het type opnieuw of geef de lijst terug.',
  add_samples: 'Voeg monster(s) toe aan de Ronde',
  copy_this_sample: `Monster dupliceren`,
  remove_this_sample: `Het monster verwijderen`,
  drag_samples_here: `Sleep monsters hierheen`,
  drop_here: `Hier loslaten`,
  multiple_selection_tips: `Je kunt meerdere monsters tegelijk selecteren voor hetzelfde monstertype. Klik op '+' en '-' om het uit te proberen.`,
  all_add_once_tips: `Klik op de knop 'Alles selecteren' om automatisch 1 monster toe te voegen aan elk geselecteerd monstertype.`,
  copy_confirm_tip: `Weet je zeker dat je het monster wilt repliceren?`,
  user_non_abi_user: 'Nieuwe tijdelijke gebruiker',
  language_of_email_invitation: 'Taal van e-mailuitnodiging',
  add_non_abi_users_to_round:
    'Tijdelijke gebruiker ontvangt een uitnodiging per e-mail met een link om de specifieke proeverij bij te wonen.',
  change_non_abi_users_to_round:
    'Tijdelijke proever die je hebt uitgenodigd ontvangt een uitnodiging per e-mail met een link om deze proeverij bij te wonen.',
  guest: 'Gast',
  email_to_all: 'E-mail naar iedereen',
  send_email: 'E-mail met uitnodiging versturen',
  temporary_non_abi_taster: 'Tijdelijke proever',
  user_type: 'Gebruikerstype',
  email_invitation_delivery_request_sent: 'Uitnodiging per e-mail verstuurd.',
  incorrect_e_mail_formatting: 'Onjuiste e-mailopmaak',
  all_tasters: 'Alle proevers',
  tasters: 'Proevers',
  key_tasters: 'Sleutelproevers',
  non_key_tasters: 'Niet-sleutelproevers',
  taster_already_started_cannot_change:
    'Proever is al begonnen, kan niet worden gewijzigd',
  temporary: 'Tijdelijke gebruiker',
  maximum_number_of_samples_is: `Het maximale aantal monsters is`,
  sample_added: 'Monster toegevoegd',
  click_to_view_scale_of_flavour_intensities: `Klik op de link om de gedetailleerde intensiteitsschalen te zien`,
  list_next_week_plan: 'Plan voor volgende week',
  common_time_zone: 'Tijdzone',
  common_last_response_time: `Laatste reactietijd`,
  new_week_plan: 'Nieuw Weekplan',
  invited_week: 'Uitgenodigde week',
  email_language: `Taal e-mail`,
  save_and_send_email: `E-mail opslaan en verzenden`,
  common_start_time: 'Begintijd',
  common_end_time: 'Eindtijd',
  session_name_email_subject: `Naam sessie / onderwerp e-mail`,
  location: 'Locatie',
  edit_week_plan: 'Wekplan bewerken',
  email_response: 'Antwoord per e-mail',
  round_remove_plan: 'Weet u zeker dat u de Ronde wilt verwijderen',
  view_week_plan: 'Weekoverzicht bekijken',
  are_you_confirming_to_send_the_confirmation_email: `Bevestigt u het verzenden van de bevestigingsmail`,
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation: `Elke 10 minuten werkt het systeem de e-mailreactie van de uitnodiging voor het volgende weekplan bij`,
  documents_upload_tips: 'Bestandsuploads ondersteunen alleen {{field}}',
  ignore_submit: 'Ignoreren&Verzenden',
  if_count_as_kpi:
    'Als dit veld leeg is, worden de KPIs als "Count as KPI" gekennzeichnet',
  confirmed_count: 'Bevestigde telling',
  accepted: 'Geaccepteerd',
  declined: 'Afgewezen',
  no_response: 'Geen reactie',
  reminder_time: 'Herinneringstijd',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    'Weet je zeker dat je de begin- en eindtijd van de sessie die je hebt geselecteerd wilt verwijderen en wilt wijzigen naar een andere uitgenodigde week?',
  apply_to_all_sessions_location_tasters: `Pas 'Locatie' en 'Tasters' toe op volgende sessies`,
  mcs_tasting: 'KPI Proeverij',
  qcs_tasting: 'KPI Proeverij',
  mcs_tasting_tips: `Selecteer Ja als deze ronde MCS/KPI-monsters bevat, dan past het systeem de betreffende KPI-code toe per merk monster.`,
  round_samples_shuffle_confirm: 'Weet je zeker dat je de Sets wilt schudden?',
  all_count_as_kpi: 'Alle tellen mee als KPI',
  msc_tasting_tour_mask:
    'Het systeem identificeert automatisch gerelateerde KPI-codes op basis van getelde monsters met de juiste KPI-maand, zodat je NIET verschillende merken in één ronde hoeft op te splitsen.',
  competition: 'Concurrentie',
  copy_link: 'Link kopiëren',
  open_link: 'Open Link',
  common_download_img: `IMG downloaden`,
  please_select_taster: 'Selecteer proeverij',
  user_principal_name: 'Voornaam gebruiker',
  user_status: 'Gebruikersstatus',
  termination_date: 'Einddatum',
  function_level: 'Functieniveau',
  last_update_time: 'Tijd laatste update',
  system_related: 'Systeem gerelateerd',
  workday_related: 'Werkdag gerelateerd',
  employee_id: 'Werknemer-ID',
  zitec_project_name: 'Naam project',
  applicant: 'Aanvrager',
  applicant_date: 'Aanvraagdatum',
  test_method: 'Testmethode',
  liquid_category: 'Vloeistof Categorie',
  conditions: 'Omstandigheden',
  time_points: 'Tijd Punten',
  execution_date: 'Uitvoeringsdatum',
  execution_by_time_points: 'Berekende uitvoeringsdatum door tijdpunten',
  invitation_start_time: 'Starttijd uitnodiging',
  invitation_end_time: 'Eindtijd uitnodiging',
  invitation_reminder: 'Uitnodiging Herinnering',
  application_form: 'Aanvraagformulier',
  application_form_result: 'Aanvraagformulier Resultaat',
  upload_result: 'Resultaat uploaden',
  zitec_sessions: 'ZITEC-sessies',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'Nieuwe ZITEC-sessie',
  common_search_applicant: 'Aanvrager zoeken',
  history_record: 'Geschiedenis',
  common_quarterly: 'Kwartaal',
  common_month: 'Maand',
  kpi_report: 'KPI Rapport',
  kpi_result: 'Anaplan bestand',
  action_log: 'Actielogboek',
  validate_data: 'Gegevens valideren',
  push_anaplan_window_open_date: 'Push Anaplan Venster Open Datum:',
  unLock_kpi: 'KPI ontgrendelen',
  lock_kpi: 'KPI vergrendelen',
  locked: 'Vergrendeld',
  unlocked: 'Ontgrendeld',
  menu_kpi_lock: 'KPI Vergrendeling',
  freshness_kpi_lock: 'Versheid Vergrendeling',
  in_profile_kpi_lock: 'In Profile Lock',
  are_you_sure_you_want_to_lock_kpi:
    'Weet u zeker dat u de KPI voor {{field}} wilt vergrendelen',
  are_you_sure_you_want_to_unlock_kpi:
    'Weet je zeker dat je KPI {{field}} wilt ontgrendelen',
  lock_kpi_month_zone:
    'Uw actie is beperkt vanwege de vergrendeling van KPI-steekproef die is geactiveerd voor een bepaalde KPI-maand en -zone. Neem bij vragen contact op met uw zone-eigenaar voor meer informatie over de vergrendeling van KPI-gegevens.',
  lock_freshness_kpi_month_zone:
    'Uw actie is beperkt vanwege de vergrendeling van KPI-steekproef die is geactiveerd voor een bepaald KPI-kwartaal en -zone. Neem bij vragen contact op met uw zone-eigenaar voor meer informatie over de vergrendeling van KPI-gegevens.',
  submit_timeout: 'Indienen mislukt, probeer het later opnieuw!',
  anaplan_un_upload_tips: 'Wacht op het volgende geopende Anaplan venster!',
  anaplan_un_confirm_tips: 'Bevestig de KPI data voor een bepaalde maand!',
  confirmed: 'Bevestigd',
  confirm_data: 'Bevestig gegevens',
  flavor_groups: `Smaakgroepen`,
  compound: 'Samengesteld',
  sit_code_not_exist:
    'Deze stoelcode bestaat niet, let op de stoelcode-indeling zoals 001, 002.',
  sit_code_chose: 'Deze stoelcode is gekozen, voer uw juiste stoelcode in.',
  kpi_lock: 'KPI vergrendelen',
  kpi_confirmation: 'KPI bevestiging',
  global_kpi_lock: 'Global KPI Vergrendeling',
  select_month: 'Selecteer een maand',
  need_to_wait_global_lock: 'Je moet wachten tot global vergrendeld is.',
  monthly_kpi_locked_zones: 'Maandelijkse KPI Gesloten zones',
  flavor_confirm_save: `De niet-geselecteerde smaak '{{field}}' staat in de toegevoegde voorbeelden. Als u bevestigt om de huidige smaakconfiguratie op te slaan, worden de bijbehorende voorbeelden verwijderd`,
  temporary_admin: 'Tijdelijke Admin',
  unhide_sample_details: 'Details monster verwijderen',
  hide_sample: 'Verberg monster',
  download_report_timeout_error_message:
    'Time-out toegang, controleer de netwerkverbinding.',
  you_can_only_select_up_to:
    'Je kunt maximaal {{field}} selecteren, verminder het aantal keuzes.',
  push_anaplan: 'Push Anaplan',
  pushed: 'Push Voltooiing',
  self_evaluation_report: 'Klik om het zelfevaluatierapport te downloaden',
  date_range: 'Datumbereik',
  kpi_month_range: 'KPI Maandbereik',
  quick_select: 'Snel selecteren',
  current_month: 'Huidige maand',
  current_year: 'Huidig jaar',
  a_whole_year: 'Een heel jaar',
  download_self_evaluation_report: 'Zelfevaluatierapport downloaden',
  select_tasters: 'Selecteer proevers',
  create_ticket: 'Ticket Aanmaken',
  sensory_intelligent_platform: 'Intelligent Sensory Platform - PBI',
  external_links: 'Externe links',
  evaluation_report: 'Evaluatierapport',
  download_evaluation_report: 'Download evaluatierapport',
  taster_type: 'Type proeverij',
  taster_evaluation_tip:
    'Nu kunt u hier klikken om uw zelfbeoordelingsrapport te downloaden!',
  admin_evaluation_tip:
    'Klik hier om het evaluatierapport van de proevers te downloaden',
  kpi_sample: 'KPI-voorbeeld',
  add_to_download_list: 'Toevoegen aan downloadlijst',
  to_download_list: 'Om te downloaden',
  selected_tasters: 'Geselecteerde proevers',
  generation_time: 'Generatietijd',
  start_month: 'Beginmaand',
  end_month: 'Eindmaand',
  download_all: 'Alles downloaden',
  new_physchem_tips:
    'Nu kunt u hier klikken om fysische en chemische eigenschappen voor monsters toe te voegen',
  view_physchem_tips: `Nu kunt u hier klikken om de fysische en chemische eigenschappen van de monsters van de huidige ronde te bekijken`,
  physchem_disabled_tips:
    'Kan phychem niet bekijken wanneer monsters verborgen zijn',
  package_code: `Verpakkingscode`,
  concentration_at_fu: 'Concentratie bij 1 smaakeenheid',
  base_beer: 'Basisbier',
  flavor_intensities_scale: `Smaakintensiteitenschaal`,
  flavor_unit: 'Smaakeenheid',
  add_a_sample: 'Een monster toevoegen',
  common_kpi_quarter: 'KPI Kwartaal',
  sample_duplicated_quarter_kpi_message:
    'Er is al een KPI voor het kwartaal, merk en de site die u hebt geselecteerd en u kunt niet opslaan.',
  select_quarter: 'Selecteer kwartaal',
  please_select_kpi_quarter: 'Selecteer KPI-kwartaal',
  error_fields: `Foutvelden`,
  your_answer: 'Uw antwoord',
  preference: 'Voorkeurs',
  please_select_preference_group:
    'U moet uw voorkeuren selecteren voordat u het formulier verstuurt!',
  monthly_report: 'Maandrapport',
  draft: 'Concept',
  confirm_send: 'Bevestigen en verzenden',
  sent_completion: 'Verzonden voltooid',
  send_draft: 'Concept verzenden',
  send_draft_monthly_report: 'Verzend het maandrapport naar uw e-mailadres.',
  please_confirm_the_recipients: 'Bevestig de ontvangers van het maandrapport',
  total_recipients: 'Totaal aantal ontvangers',
  sending: 'Verzenden',
  sending_monthly_report_tips1: `Uw verzoek wordt momenteel verwerkt.`,
  sending_monthly_report_tips2: `Controleer het 'Actielogboek' voor het resultaat.`,
  configure_upgrade_center: 'Upgrade Center configureren',
  sprint_content: 'Sprint-inhoud',
  release_date: 'Releasedatum',
  add_sprint: 'Sprint toevoegen',
  sprint_materials: 'Sprint-materialen',
  upgrade_center: 'Upgrade Center',
  function: 'Functie',
  my_evaluation_report: 'Mijn evaluatierapport',
  upgrade_center_remove_sprint_number:
    'Weet u zeker dat u dit sprintnummer wilt verwijderen',
  sprint_version_tips: 'Klik om de sprintmaterialen te bekijken.',
  edit_sprint: 'Sprint bewerken',
  new_sprint_tips: 'Nu kunt u hier klikken om het sprintmateriaal te bekijken.',
  production_date_range: 'Productiedatum bereik',
  preparation: 'Voorbereiding',
  panel: 'Panel',
  session: 'Sessie',
  product: 'Product',
  attribute: 'Attribuut',
  common_menu_samples: 'Monster',
  common_menu_rounds: 'Ronden',
  common_menu_groups: 'Groepen',
  common_menu_suspension_list: 'Suspensie',
  common_menu_planning_week_sessions: 'Planning week sessies',
  common_menu_zitec_sessions: 'ZITEC sessies',
  common_menu_brands: 'Merken',
  common_menu_kpi_brands: 'KPI-merken',
  common_menu_packages: 'Pakketten',
  common_menu_styles: 'Stijlen',
  common_menu_malt_variety: 'Moutsoort',
  common_menu_intensities: 'Intensiteiten',
  common_menu_categories: 'Categorieën',
  common_menu_attributes: 'Attributen',
  common_menu_user_management: 'Gebruikersbeheer',
  common_menu_role_management: 'Rollenbeheer',
  common_menu_permission_control: 'Rechtentoetsing',
  system: 'Systeem',
  select_taste_type: 'Selecteer proevertype',
  select_round: 'Selecteer ronde',
  a_previous_request_is_still_being_processed:
    'Een eerdere aanvraag wordt nog verwerkt. Probeer het later opnieuw.',
  select_item: 'Selecteer {{field}}',
  common_new_kpi_brand_button: 'Nieuwe KPI-merk',
  common_target: 'Doel',
  common_focus_brands: 'Focus Merken',
  common_strategic_brands: 'Strategische Merken',
  kpi_brands_new_page_description:
    'Interface voor het maken van een nieuwe KPI-merk, met functies om KPI-merkinformatie in te vullen, in te dienen en op te slaan.',
  kpi_brands_edit_page_description:
    'KPI Brand bewerken interface, met functies om KPI Brand informatie bij te werken, in te dienen en op te slaan.',
  kpi_brands_edit_page_description_prefix:
    'KPI-merken bekijken en configureren voor ',
  kpi_brands_page_description:
    'Beheerinterface voor KPI-merken, met weergave-, inzend- en beoordelingsfuncties.',
  table_apply: 'Toepassen',
  table_clear: 'Wissen',
  table_search: 'Zoeken',
  table_enter_to_filter: 'Typ om te filteren...',
  table_select_to_filter: 'Selecteer om te filteren...',
  table_select_all: 'Alles selecteren',
  table_select_all_aria: 'Alle rijen selecteren',
  table_select_row_aria: 'Rij selecteren',
  table_filter_by: 'Filteren op',
  table_clear_filters: 'Filters wissen',
  table_reset_filters: 'Filters resetten',
  table_no_results_for_filters: 'Geen resultaten gevonden voor de toegepaste filters.',
  table_items_selected: 'items geselecteerd',
  table_sort: 'Sorteren',
  table_sort_toggle: 'Klik om de sortering te wisselen',
  table_no_options: 'Geen opties beschikbaar',
  table_reset: 'Resetten',
  table_all: 'Alle',
  table_no_results: 'Geen resultaten gevonden voor de toegepaste filters',
  common_approved_at: 'Goedgekeurd op {{date}}',
  common_rejected_at: 'Afgewezen op {{date}}',
  kpi_status_created: 'Aangemaakt',
  kpi_status_waiting_for_approval: 'Wacht op goedkeuring',
  kpi_status_approved: 'Goedgekeurd',
  kpi_status_rejected: 'Afgewezen',
  kpi_action_approve: 'Goedkeuren',
  kpi_action_reject: 'Afwijzen',
  common_by_user: 'door {{user}}',
  pagination_aria_label_next_page: 'Ga naar de volgende pagina',
  pagination_aria_label_previous_page: 'Ga naar de vorige pagina',
  pagination_aria_label_first_page: 'Ga naar de eerste pagina',
  pagination_aria_label_last_page: 'Ga naar de laatste pagina',
  pagination_aria_label_input:
    'Voer de gewenste pagina in, van 1 tot {totalItems}',
  pagination_aria_label_items_per_page:
    '{pageSize} items per pagina geselecteerd, klik om te wijzigen',
  pagination_lines_per_page: 'Regels per pagina',
  pagination_total_pages: 'van {totalPages}',
  pagination_total_elements:
    '{firstItem}-{lastItem} van {totalItems} resultaten',
  pagination_no_results: 'Geen resultaten gevonden',
  kpi_brand_successfully_saved: 'KPI-merk succesvol opgeslagen!',
  kpi_brand_saved_description:
    'Bekijk het in het KPI-merk hieronder. Dit is slechts een tijdelijke opslag, de goedkeuringsinzending is nog niet voltooid.',
  kpi_brand_failed_to_save: 'KPI-merk opslaan mislukt.',
  kpi_brand_save_failed_description: 'Probeer het later opnieuw.',
  kpi_brand_successfully_submitted: 'KPI-merk succesvol aangemaakt!',
  kpi_brand_submitted_description:
    'Bekijk het in het KPI-merk hieronder. Controleer de goedkeuringsvoortgang op de detailpagina; dit KPI-merk is pas beschikbaar na goedkeuring.',
  kpi_brand_failed_to_submit: 'KPI-merk aanmaken mislukt.',
  kpi_brand_submit_failed_description: 'Probeer het later opnieuw.',
  flavor_id_discussion: 'Smaakidentificatiediscussie',
  view_and_discussion_for: 'Bekijken en bespreken voor',
  common_cup: 'Glas',
  tasters_joined: 'Deelnemende proevers',
  tasters_all_correct: 'Proevers alles correct',
  total_accuracy: 'Totale nauwkeurigheid',
  accuracy: 'Nauwkeurigheid',
  all_correct: 'Alles correct',
  otherwise: 'Overig',
  result: 'Resultaat',
  Key: 'Sleutel',
  nonkey: 'Niet-sleutel',
  common_guest: 'Gast',
  view_correct_answers: 'Juiste antwoorden bekijken',
  hide_correct_answers: 'Juiste antwoorden verbergen',
  change_to_table: 'Naar tabel wisselen',
  change_to_card: 'Naar kaarten wisselen',
  not_answered: 'Niet beantwoord',
  actions: 'Acties',
  actions_page_description:
    'Bekijk alle Acties die door gebruikers zijn aangemaakt tijdens de proefsessie.',
  action_created_by: 'Aangemaakt door',
  my_actions: 'Mijn Acties',
  action_list_info: 'De actie wordt aangemaakt nadat de ronde is gesloten.',
  unsaved_changes_warning:
    'U hebt niet-opgeslagen wijzigingen. Weet u zeker dat u wilt afsluiten?',
  common_go_back: 'Terug',
  cancel_create_action_title: 'Actie aanmaken annuleren?',
  cancel_edit_action_title: 'Actie bewerken annuleren?',
  cancel_create_action_confirm: 'Actie aanmaken annuleren',
  cancel_edit_action_confirm: 'Actie bewerken annuleren',
  unsaved_changes_description:
    'U hebt inhoud in het formulier ingevoerd. Bij annuleren gaan alle niet-opgeslagen gegevens verloren. Wilt u doorgaan?',
  unsaved_changes_edit_description:
    'U hebt de inhoud van het formulier gewijzigd. Bij annuleren gaan alle niet-opgeslagen wijzigingen verloren. Wilt u doorgaan?',
  action_update_failed_desc: 'Probeer het zo meteen opnieuw.',
  action_change_status_successfully: 'Status gewijzigd!',
  action_change_status_successfully_desc:
    'De status van de actie is gewijzigd in {{status}}.',
  action_change_status_failed: 'De status kon niet worden gewijzigd',
  action_change_status_failed_desc:
    'De status van de actie kon niet worden gewijzigd. Probeer het opnieuw.',
  download_report_success: 'Rapporten succesvol gedownload!',
  download_report_success_desc: 'Bekijk ze in uw downloadmap.',
  download_self_evaluation_report_success:
    'Zelfevaluatierapport succesvol gedownload!',
  download_report_failed: 'Rapporten konden niet worden gedownload.',
  download_report_failed_desc: 'Probeer het over een moment opnieuw.',
  evaluation_report_add_success: 'Rapport succesvol toegevoegd!',
  evaluation_report_add_success_desc:
    "Bekijk het in het evaluatierapport 'Te downloaden'.",
  evaluation_report_add_failed: 'Rapport kon niet worden toegevoegd.',
  evaluation_report_add_failed_desc: 'Probeer het over een moment opnieuw.',
  add_taster: 'Proever toevoegen',
  alcohol_concentration_result: 'Resultaat alcoholconcentratie',
  absence_save_success: 'Afwezigheidsreden succesvol toegevoegd!',
  absence_save_success_desc: 'Bekijk deze bij ingediende afwezigheden.',
  submitted_absence: 'Ingediende afwezigheden',
  no_absence_to_show: 'Geen afwezigheden om weer te geven',
  no_more_data: 'Geen verdere gegevens',
  absence_delete_success: 'Afwezigheidsreden succesvol verwijderd!',
  absence_delete_success_desc: 'Bekijk de bijgewerkte lijst bij ingediende afwezigheden.',
  absence_delete_confirm_title: 'Afwezigheid verwijderen?',
  absence_delete_confirm_description: 'Afwezigheidsrecord [{{start}} - {{finish}}] wordt permanent verwijderd. Wilt u doorgaan?',
  absence_delete_confirm_delete: 'Verwijderen',
  absence_save_failed: 'Afwezigheidsreden kon niet worden toegevoegd',
  absence_save_failed_desc: 'Probeer het over een moment opnieuw.',
  absence_duplicate_date_desc:
    'Er bestaat al een afwezigheidsregistratie voor de geselecteerde datum. Dubbele inzendingen zijn niet toegestaan.',
  absence_delete_failed: 'Afwezigheidsreden kon niet worden verwijderd',
  absence_delete_failed_desc: 'Probeer het over een moment opnieuw.',
  role_management_change_role: 'Rol wijzigen',
  role_management_reset_success: 'Machtigingen zijn succesvol hersteld!',
  role_management_reset_success_desc: 'De machtigingen van deze rol zijn teruggezet naar de standaardconfiguratie.',
  role_management_reset_failed: 'Machtigingen konden niet worden hersteld.',
  role_management_reset_failed_desc: 'Probeer het over een moment opnieuw.',
  role_management_switch_role_title: 'Wijzigingen negeren?',
  role_management_switch_role_description: 'Er zijn niet-opgeslagen wijzigingen in de machtigingen. Als u van rol wisselt, worden deze genegeerd. Doorgaan?',
  role_management_switch_role_confirm: 'Rol wijzigen',
  role_management_created: 'Aangepaste rol is succesvol aangemaakt!',
  role_management_created_desc: 'Bekijk deze in het onderstaande machtigingenbeheer.',
  role_management_permissions_failed: 'Machtigingen konden niet worden geladen.',
  role_management_create_failed: 'De rol kon niet worden aangemaakt.',
  role_management_create_required: 'Voer een rolnaam in en selecteer een machtigingsset.',
  role_management_create_failed_desc: 'Probeer het over een moment opnieuw.',
  role_management_save_success: 'Rolmachtigingen succesvol bijgewerkt!',
  role_management_save_success_desc: 'De wijzigingen zijn opgeslagen. Je kunt ze hieronder in het machtigingenbeheer bekijken.',
  role_management_save_failed: 'De rolwijzigingen konden niet worden opgeslagen.',
  role_management_save_failed_desc: 'Probeer het over een moment opnieuw.',
  role_management_permission: 'Functie',
  role_management_view: 'Weergeven',
  role_management_edit: 'Bewerken',
  role_management_approve: 'Goedkeuren',
  role_management_search: 'Rollen zoeken',
  role_management_current_role_prefix: 'Je huidige rol is',
  role_management_create: 'Aangepaste rol maken',
  role_management_save_changes: 'Wijzigingen opslaan',
  common_apply: 'Toepassen',
  role_management_reset_title: 'Machtigingen terugzetten naar standaard?',
  role_management_reset_description: 'De machtigingen van de rol worden teruggezet naar de standaardconfiguratie en alle handmatige wijzigingen worden verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
  cancel_create_role_title: 'Het maken van de aangepaste rol annuleren?',
  cancel_create_role_confirm: 'Maken van rol annuleren',
  cancel_create_role_description: 'Je hebt gegevens in het formulier ingevoerd. Bij annuleren worden alle niet-opgeslagen gegevens verwijderd. Wil je doorgaan?',
  role_management_delete_title: 'Aangepaste rol verwijderen?',
  role_management_default_role: 'de standaardrol',
  role_management_delete_preview_no_users: 'De aangepaste rol ‘{{role}}’ wordt permanent verwijderd. Wil je doorgaan?',
  role_management_create_title: 'Aangepaste rol maken',
  role_management_role_name: 'Rolnaam',
  role_management_permission_set: 'Machtigingsset om aan te passen',
  role_management_role_name_placeholder: 'Voer de rolnaam in',
  role_management_permission_set_placeholder: 'Selecteer een machtigingsset',
  role_management_reset_success: 'Machtigingen succesvol opnieuw ingesteld!',
  role_management_reset_success_desc: 'De machtigingen van deze rol zijn teruggezet naar de standaardconfiguratie.',
  role_management_reset_failed: 'Machtigingen konden niet opnieuw worden ingesteld.',
  role_management_reset_failed_desc: 'Probeer het over een moment opnieuw.',
};
